export default "__VITE_ASSET__DtC5MiDS__"